/*
 * The mockup's `.app` grid: sidebar column and main column, the whole viewport tall. The page scrolls
 * inside `main`, so the sidebar and the topbar stay put.
 */
.shell {
  display: grid;
  grid-template-columns: var(--layout-sidebar) minmax(0, 1fr);
  block-size: 100vh;
  background-color: var(--surface);
  color: var(--text);
  transition: grid-template-columns var(--motion-duration) var(--motion-ease);
}

.shell[data-sidebar="rail"] {
  grid-template-columns: var(--layout-rail) minmax(0, 1fr);
}

.shell[data-sidebar="drawer"] {
  grid-template-columns: minmax(0, 1fr);
}

.sidebar {
  min-inline-size: 0;
  min-block-size: 0;
  border-inline-end: 1px solid var(--border);
}

.main {
  display: flex;
  flex-direction: column;
  min-inline-size: 0;
  min-block-size: 0;
}

/* The mockup's `.search-btn`: ghost, its text and key cap hidden below 1024px. */
.search {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  block-size: var(--control-height);
  padding: 0 var(--space-3);
  border: 0;
  border-radius: var(--radius-control);
  background: transparent;
  color: var(--text-subtle);
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
}

.search:hover {
  background: var(--state-hover);
  color: var(--text);
}

.search:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.shell[data-sidebar="drawer"] .searchText {
  display: none;
}

/* The mockup's `.content` + `.page`: the page column, centred up to 1280px INCLUDING its 32px sides
   (1216px of content), as `.page { max-width: 1280px; padding: 0 32px }` draws it. */
.content {
  flex: 1;
  min-block-size: 0;
  overflow: auto;
  overflow-x: hidden;
  padding: var(--space-6) max(var(--space-8), calc((100% - 1216px) / 2)) var(--space-12);
}

.shell[data-sidebar="drawer"] .content {
  padding: var(--space-4) var(--space-4) var(--space-12);
}

/* The Lienzo (`/lienzo`, `/lienzo/:id`): the editor fills the content area, edge to edge. */
.content[data-layout="canvas"],
.shell[data-sidebar="drawer"] .content[data-layout="canvas"] {
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
}

/* Focus mode (UX-05): no sidebar column at all. */
.shell[data-sidebar="focus"] {
  grid-template-columns: minmax(0, 1fr);
}
